import { useRef, useState } from "react";
import { SafeImg } from "@/components/SafeImg";

// Mobile-only swipeable photo strip with position dots.
export const SwipeGallery = ({ images, title, square }) => {
  const ref = useRef(null);
  const [index, setIndex] = useState(0);
  const onScroll = () => {
    const el = ref.current;
    if (el) setIndex(Math.round(el.scrollLeft / el.clientWidth));
  };
  return (
    <div data-testid="product-swipe-gallery" data-no-page-swipe={images.length > 1 ? "" : undefined} className="sm:hidden -mx-4 relative">
      <div ref={ref} onScroll={onScroll} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar">
        {images.map((src, i) => (
          <div key={i} className={`snap-center shrink-0 w-full ${square ? "aspect-square" : "aspect-[3/4]"} bg-[#F5EFE6]`}>
            <SafeImg src={src} alt={i === 0 ? title : ""} loading={i === 0 ? "eager" : "lazy"} className="h-full w-full object-cover" />
          </div>
        ))}
      </div>
      {images.length > 1 && (
        <div className="absolute bottom-3 inset-x-0 flex justify-center gap-1.5" data-testid="gallery-dots">
          {images.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === index ? "w-5 bg-[#C5A059]" : "w-1.5 bg-white/70"}`} />
          ))}
        </div>
      )}
      {images.length > 1 && (
        <span className="absolute top-3 right-3 bg-[#0F0F0F]/70 text-white font-mono text-[10px] px-2 py-1">{index + 1}/{images.length}</span>
      )}
    </div>
  );
};
